export default{
    profiler: 'Profiler Gids'
}